"use client";
import React, { useState } from "react";
import { HoveredLink, Menu, MenuItem } from "../ui/navbar-menu";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "@/GlobalRedux/UserSlice";
import { useRouter } from "next/navigation";

const Logo =
  "https://res.cloudinary.com/dcwai4hwc/image/upload/v1729575815/nubitlogo_uu0waa.png";

export function NavbarDemo() {
  return (
    <div className="relative w-full text-white flex items-center justify-center">
      <Navbar className="top-2 " />
    </div>
  );
}

function Navbar({ className }) {
  const [active, setActive] = useState(null);
  const pathName = usePathname();
  const dispatch = useDispatch();
  const router = useRouter();
  const { users } = useSelector((state) => state.user);

  const LogoutUser = () => {
    dispatch(Logout());
    router.push("/login");
  };

  return (
    <>
      <div
        className={cn(
          "fixed top-4 md:top-6 inset-x-0 max-w-2xl text-white mx-auto z-50 px-4",
          className
        )}
      >
        <Menu setActive={setActive} className="text-white">
          <div className="flex items-center justify-center pr-2 mr-2 border-r border-white/10">
            <Link href={"/"} className="transition-transform duration-200 hover:scale-105">
              <Image
                alt="Nubit Login - Secure Access to Your Account"
                className={cn("object-contain scale-[1.15]")}
                width={60}
                height={80}
                // style={{ width: "60px", height: "80px" }}
                src={Logo}
              />
            </Link>
          </div>

          <div
            className={`${users?.email === "sales@gmail.com"
                ? "flex h-full items-center justify-between"
                : "flex h-full items-center justify-between"
              } w-72 sm:w-96`}
          >
            {/* ABOUT */}
            <MenuItem
              navigation="/about"
              setActive={setActive}
              active={active}
              className={`${pathName === "/about"
                  ? "text-blue-400 underline fontbold translate-x-1"
                  : ""
                }`}
              item="About"
            >
              <div className="flex flex-col gap-3 ">
                <HoveredLink
                  href="/AddReviews"
                  className={
                    users?.data.role === "Admin"
                      ? "block sm:hidden"
                      : "hidden"
                  }
                >
                  Add Reviews
                </HoveredLink>

                <HoveredLink href="/blogs" className="flex sm:hidden">
                  Blog
                </HoveredLink>

                <HoveredLink href="/portfolio">
                  Portfolio
                </HoveredLink>

                <Link href={"/#projects"}>
                  <span className="text-slate-200 font-medium text-sm hover:text-brand-300 hover:translate-x-1 inline-block transition-all duration-200">
                    Projects
                  </span>
                </Link>

                <HoveredLink href="/privacypolicy">
                  Privacy Policy
                </HoveredLink>
              </div>
            </MenuItem>

            {/* BLOGS */}
            <MenuItem
              className={`${pathName === "/blogs"
                  ? "text-blue-400 underline fontbold translate-x-1"
                  : ""
                } hidden sm:block`}
              navigation="/blogs"
              setActive={setActive}
              active={active}
              item="Blogs"
            >
              <HoveredLink
                href="/AddReviews"
                className={
                  users?.data.role === "Admin" ? "block" : "hidden"
                }
              >
                Add Reviews
              </HoveredLink>
            </MenuItem>

            {/* CONTACT */}
            <MenuItem
              navigation="/contact"
              setActive={setActive}
              active={active}
              item="Contact"
            >
              <div className="flex flex-col space-y-4 text-sm ">
                <HoveredLink
                  href="/contact"
                  className={`${pathName === "/contact"
                      ? "text-blue-400 underline fontbold translate-x-1"
                      : ""
                    }`}
                >
                  Contact Us
                </HoveredLink>

                <HoveredLink
                  href="/careerform"
                  className={`${pathName === "/careerform"
                      ? "text-blue-400 underline fontbold translate-x-1"
                      : ""
                    }`}
                >
                  Career Form
                </HoveredLink>

                <HoveredLink
                  href="/showcareerform"
                  className={
                    users?.data.role === "Admin" ? "block" : "hidden"
                  }
                >
                  Show Career Form
                </HoveredLink>
              </div>
            </MenuItem>

            {/* SERVICES */}
            <MenuItem
              navigation="/#services"
              setActive={setActive}
              active={active}
              item="Services"
            >
              <div className="flex flex-col space-y-4 text-sm">
                <HoveredLink href="/#services">
                  Web Development
                </HoveredLink>

                <HoveredLink href="/#services">
                  Mobile Application
                </HoveredLink>

                <HoveredLink href="/#services">
                  UI/UX
                </HoveredLink>

                <HoveredLink href="/#services">
                  BPO
                </HoveredLink>
              </div>
            </MenuItem>

            {/* LOGIN / LOGOUT */}
            {users?.data.role === "Admin" ? (
              <span
                onClick={LogoutUser}
                className="btn-primary cursor-pointer !text-xs md:!text-sm !py-1.5 !px-4"
              >
                Logout
              </span>
            ) : (
              <span
                onClick={() => {
                  router.push("/login");
                }}
                className="btn-primary cursor-pointer !text-xs md:!text-sm !py-1.5 !px-4"
              >
                Login
              </span>
            )}
          </div>
        </Menu>
      </div>
    </>
  );
}